export default __webpack_public_path__ + "static/media/Imperial-Fleet-01.0fb58ff0.jpg";